import React, { useEffect, useState } from "react";
import { components } from "react-select";
import CommonModal from "../utils/commonModal";
import { connect } from "react-redux";
import Loading from "../utils/loader";
import { MdClear } from 'react-icons/md';
import CustomSelect from "./customSelect";
import { IdsCheck,deviceType } from "../../utils/registrationUtils";
import { MdOutlineArrowDropDown, MdOutlineArrowDropUp } from 'react-icons/md';

const CareersRegisterMultiSelect = (props) => {
  const { name, values, setFieldValue, validationSchema, errors, touched, handleBlur } = props;
  const [open, setOpen] = useState(false);
  const [dropdownDatas, setDropdownDatas] = useState([]);
  const [searchData, setSearchData] = useState("")
  const [showLimit, setShowLimit] = useState(false);
  const [temporaryValues, setTemporaryValues] = useState(values[name]);

  useEffect(() => {
    let dropdownsData = [];
    let areaOfInterestData = [];
    if (props.dropdownData?.values?.length > 0 && name == "area_of_interest") {
      dropdownsData = props.dropdownData?.values?.slice(0,15)?.map(
        (key) => {
            return {
              id: key.id ?? key.branch_id,
              label: key.value,
              branch_type: key?.branch_type,
              b_count: key?.b_count,
              group_id: key?.group_id,
              group_name: key?.group_name,
              is_group: key?.is_group
            };
        }
      );
    }else if(props.dropdownData?.values?.length > 0 && name != "area_of_interest"){
        dropdownsData = props.dropdownData?.values?.map(
          (key) => {
              return {
                id: key.id ?? key.branch_id,
                label: key.value,
                branch_type: key?.branch_type,
                b_count: key?.b_count
              };
          }
        );
    }
    // to filter values for area of interest
    if(name == "area_of_interest"){
      let dropdownIds = props.dropdownData?.values?.map(obj => obj?.id || obj?.branch_id)
      let updatedSelectedValues =  values[name]?.filter((obj) => dropdownIds?.includes(obj.id))
      setFieldValue("area_of_interest",updatedSelectedValues)
      setTemporaryValues(updatedSelectedValues)
    }
    setDropdownDatas(dropdownsData);
  }, [props.dropdownData?.values]);

  const Option = (props) => {
    return (
      <div>      
        <components.Option {...props} className={!props.isSelected ? 'bg-white' : 'bg_gray'} >
          <span className="careers_register_custom_checkbox ai_option_cover">
            <input type="checkbox" id={props.label} checked={props.isSelected}/>{" "}
            <label htmlFor={props.label}>{props.label}</label>
          </span>
        </components.Option>
      </div>
    );
  };

  function isObjectPresent(arr, targetObject) {
    if(arr.length > 0){
    return arr?.some(obj =>
      obj.id === targetObject.id && obj.label === targetObject.label
    );
    }
  }
  let removeItem = (e,object) => {
    e.preventDefault();
    e.stopPropagation();
    //remove outside values
    let deselectInputValues = values[name]?.filter(obj => obj.id !== object?.id);
    props.setFieldValue(name, deselectInputValues);

    //sync outside values to inside dropdown values
    let deselectDropdownInputValues = values[name]?.filter(obj => obj.id !== object?.id);
    props.setFieldValue(name, deselectDropdownInputValues);
  }

  const areaOfInterestInputChange = (e) => {
    setSearchData(e);
    let dropdownsData = [];
    if (props.dropdownData?.values?.length > 0 && name == "area_of_interest") {
       if(e?.length > 0){
        dropdownsData = props.dropdownData?.values?.map(
          (key) => {
              return {
                id: key.id ?? key.branch_id,
                label: key.value,
                branch_type: key?.branch_type,
                b_count: key?.b_count,
                group_id: key?.group_id,
                group_name: key?.group_name,
                is_group: key?.is_group
              };
          }
        )
      }else{
        dropdownsData = props.dropdownData?.values?.slice(0,15)?.map(
          (key) => {
              return {
                id: key.id ?? key.branch_id,
                label: key.value,
                branch_type: key?.branch_type,
                b_count: key?.b_count,
                group_id: key?.group_id,
                group_name: key?.group_name,
                is_group: key?.is_group
              };
          }
        ) 
      }
      setDropdownDatas(dropdownsData);
    }
    return e
  }
  const areaOfInterestsPlaceholder = dropdownDatas?.length > props.maxLimit ?  `Select only upto ${props.maxLimit + 1} ${props.label}` : "Your Interests";
   const handleInputDataChange =() => {
    areaOfInterestInputChange("");
    setSearchData("");
   }
  return (
    <div className={(values[name] || errors[name] || showLimit) ? "careers_register_select_card white_bg" : "careers_register_select_card"}>
      {deviceType == 'web' &&
        <>
          <CustomSelect
            name={name}
            options={dropdownDatas}
            onBlur={() => {
              setShowLimit(false);
              handleBlur({ target: { name :name} });
            }}
            backspaceRemovesValue={false}
            getOptionLabel={(opt) => opt.label}
            getOptionValue={(opt) => opt.id ?? opt.domain_id}
            value={values?.[name] ? values?.[name] : []}
            errors={(errors[name] && touched[name])}
            onChange={(option) => {
              props.setFieldValue(name, option);
            }}
            onInputChange={(e, { action }) => {
              if (action === 'input-change') {
                areaOfInterestInputChange(e)
              } else {
                setSearchData(searchData);
              }
            }}
            onMenuClose={handleInputDataChange}
            onFocus={(e, item) => {
              setShowLimit(true)
              props.handleOnFocus(e, name, item);
            }}
            isClearable={true}
            isMulti
            isOptionDisabled={(opt) =>
              values[name]?.length > props.maxLimit && !isObjectPresent(values[name], opt)
            }
            noOptionsMessage={({ inputValue }) =>
              (props.areaOfInterestLoading || props.countryLoading) ? (
                <Loading /> // You can replace this with your custom loader message
              ) : (
                "No options found"
              )
            }
          components={{Option: Option }}
            hideSelectedOptions={false}
            isSearchable
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "#ccc",
                background: state.isFocused || values[name] || (errors[name] && touched[name]) ? '#fff' : '#F8F8F8',
                borderRadius: "3px",
                minHeight: "42px",
                boxShadow: "none",
                border: (errors[name] && touched[name]) && '1px solid #b3261e',
                ":hover": {
                  borderColor: "#ccc",
                },
                overflow: "auto",
              }),
              valueContainer: (base, state) => ({
                ...base,
                padding: "5px 8px 5px 10px",
                overflow: "visible",
              }),
              option: (base, state) => ({
                ...base,
                background: state.isSelected || state.isFocused ? 'rgba(0, 0, 0, 0.04) !important;' : '#fff',
                // color: state.isOptionDisabled ? '#ccc':'#111',
              }),
              dropdownIndicator: (provided, state) => ({
                ...provided,
                color: state.isFocused ? "#999" : "#999",
                fontSize: "24px",
                display: 'none',
              }),
              indicatorSeparator: (provided, state) => ({
                ...provided,
                display: 'none',
              }),
              menuList: (base) => ({
                ...base,
                "::-webkit-scrollbar": {
                  width: "4px",
                  height: "0px",
                },
                "::-webkit-scrollbar-track": {
                  background: "#F1F1F1"
                },
                "::-webkit-scrollbar-thumb": {
                  background: "#999"
                },
                "::-webkit-scrollbar-thumb:hover": {
                  background: "#555"
                },
              }),
              
            }}
            setFieldValue={props.setFieldValue}
            label={'label'}
            maxLimit={props.maxLimit}
            showLimit={showLimit}
            dropdownDatas={dropdownDatas}
          />
        
        <span className={values[name]?.length > 0 || searchData || showLimit ? 'floating_label_active' : 'floating_label'}>{props.placeholder}</span>
        {((!values[name]?.length > 0) && (showLimit)) && <span className="floating_label" id="careers_registration__limit_info">{ name == "area_of_interest" ? areaOfInterestsPlaceholder : `Select only upto ${props.maxLimit + 1} ${props.label}`}</span>}
        </>
      }
      {deviceType == "mobile" &&
        <div className={(errors[name] && touched[name] && !open) ? "careers_register_form_card multi_check_padding invalid_field" : values[name] ? "careers_register_form_card multi_check_padding white_bg" : "careers_register_form_card multi_check_padding"}>
          <div
            className="college_stream_input_cover"
            onClick={(e, item) => {
              setOpen(true)
              props.handleOnFocus(e, props.name, item);
            }}
          >
        <>
          {(values[name]?.length > 0) && (
            <div className='selected_option_cover'>
              <div className='selected_option'>
                <span>{values[name]?.[0]?.label || values[name]?.[0]?.value}</span>
                <span
                  onClick={(e) => { 
                    removeItem(e,values[name]?.[0]);
                    e.stopPropagation();
                  }}
                  className='remove'>
                  <MdClear />
                </span>
              </div>
              {(values[name]?.length > 1) && (
                <div className='btn multi_select_more'>{`+${values[name]?.length - 1} More`}</div>
              )}
            </div>
          )}
        </>
          <span className={values[name]?.length > 0 ? 'floating_label_active' : 'floating_label'}>{props.placeholder}</span>
          <div className='custom_Select_indicator_wap'>{open ? <MdOutlineArrowDropUp /> : <MdOutlineArrowDropDown />}</div>
        </div>
        </div>
      }

      <CommonModal
        isOpen={open}
        closeModal={() => {
          setOpen(false);
          setTemporaryValues(values[name])
        }}
        classNames={{
          root: "mobile_modal",
          modal: 'custom_modal',
          modalAnimationIn: 'customEnterModalAnimation',
          modalAnimationOut: 'customLeaveModalAnimation',
        }}
        animationDuration={800}
      >
        <div className="inner_studyin_modal">
          <span className="careers_register_dropdown_heading"><b>{props.placeholder}</b></span>
          {deviceType == 'mobile' &&
            <>
            <CustomSelect
              menuIsOpen
              options={dropdownDatas}
              name={name}
              isMulti
              onBlur={handleBlur(name)}
              components={{ Option: Option }}
              getOptionLabel={(opt) => opt.label}
              getOptionValue={(opt) => opt.id ?? opt.domain_id}
              backspaceRemovesValue={false}
              isOptionDisabled={(opt) =>
                temporaryValues?.length > props.maxLimit && !isObjectPresent(temporaryValues, opt)
              }
              value={temporaryValues}
              errors={(errors[name] && touched[name])}
              onChange={(option) => {
                setTemporaryValues(option);
              }}
              isSearchable
              isSearchableForMultiSelect={
                temporaryValues?.length <= props.maxLimit || !temporaryValues?.length
              }
              hideSelectedOptions={false}
              noOptionsMessage={({ inputValue }) =>
                (props.areaOfInterestLoading || props.countryLoading) ? (
                  <Loading /> // You can replace this with your custom loader message
                ) : (
                  "No options found"
                )
              }
              // inputValue={searchData || ""}
              onInputChange={(e, { action }) => {
                if (action === 'input-change') {
                  areaOfInterestInputChange(e)
                  // setSearchData(e);
                } else {
                  setSearchData(searchData);
                }
              }}
              onMenuClose={handleInputDataChange}
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "#ccc",
                  background: state.isFocused || values[name] || (errors[name] && touched[name]) ? '#fff' : '#F8F8F8',
                  borderRadius: "3px",
                  minHeight: "42px",
                  boxShadow: "none",
                  border: (errors[name] && touched[name]) && '1px solid #b3261e',
                  ":hover": {
                    borderColor: "#ccc",
                  },
                  overflow: "auto",
                }),
                valueContainer: (base, state) => ({
                  ...base,
                  padding: "5px 8px 5px 10px",
                  overflow: "visible",
                }),
                option: (base, state) => ({
                  ...base,
                  background: state.isSelected ? 'rgba(0, 0, 0, 0.04);' : '#fff',
                  color: '#111',
                  ":hover": {
                    background: "rgba(0, 0, 0, 0.04) !important",
                  }
                }),
                dropdownIndicator: (provided, state) => ({
                  ...provided,
                  color: state.isFocused ? "#999" : "#999",
                  fontSize: "24px",
                  display: 'none',
                }),
                indicatorSeparator: (provided, state) => ({
                  ...provided,
                  display: 'none',
                }),
                menuList: (base) => ({
                  ...base,
                  "::-webkit-scrollbar": {
                    width: "4px",
                    height: "0px",
                  },
                  "::-webkit-scrollbar-track": {
                    background: "#F1F1F1"
                  },
                  "::-webkit-scrollbar-thumb": {
                    background: "#999"
                  },
                  "::-webkit-scrollbar-thumb:hover": {
                    background: "#555"
                  },
                }),
              }}
              setFieldValue={props.setFieldValue}
              // label={'label'}
              label={props.label}
              maxLimit={props.maxLimit}
              dropdownDatas={dropdownDatas}
            />
             <div className="careers_register_multiselect_button">
             <div className="careers_register_cancel_button" onClick={() => {
              setOpen(false)
              setTemporaryValues(values[name])
            }}
            >
               Cancel
             </div>
             <div className="careers_register_apply_button" onClick={() => {
                props.setFieldValue(name, temporaryValues);
                setOpen(false)

            }}>
               Apply
             </div>
           </div>
           </>
          }
        </div>
      </CommonModal>
      {!open && errors[name] && touched[name] && (
        <div className="invalid_card">
          <span className="invalid_card_text">{errors[name]}</span>
        </div>
      )}
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    areaOfInterestLoading: state.userSignUpFields.areaOfInterestLoading,
    countryLoading: state.userSignUpFields.countryLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CareersRegisterMultiSelect);
